import { SortInput } from 'components/Table'
import { AdUnitAmazonSortBy } from '../../hooks/useGetAdUnitAmazons'

export const DEFAULT_SORT: SortInput<AdUnitAmazonSortBy> = {
  by: 'updatedAt',
  direction: 'desc',
} as const

export const SORTABLE_COLUMNS: AdUnitAmazonSortBy[] = ['divId', 'path', 'updatedAt']
